import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { Dropdown } from 'react-bootstrap'
import { AddPeopleModal } from './AddPeopleModal'
import { deletePeople, getSingleCompanyPeople } from '../core/_requests'
import { toast } from 'react-toastify'
import { DeleteConfirmationModal } from '../../widgets/components/DeleteConfirmationModal'
import { Spinner } from '../../widgets/components/General/Spinner'
import NoDataPage from '../../widgets/components/NoDataPage'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import { useAuth } from '../../auth'
import { designationOptions } from '../../profile/core/_constants'

export const People = ({
  setSearchInvestorUser,
  setSortOrderUser,
  setSortByUser,
  companyPeopleData,
  getAllCompanyPeople,
  peopleApiLoading,
  publicStatus,
  publicCompanyPageLoading,
}: {
  setSearchInvestorUser: Dispatch<SetStateAction<string>>
  setSortOrderUser: Dispatch<SetStateAction<string>>
  setSortByUser: Dispatch<SetStateAction<string>>
  companyPeopleData: any
  getAllCompanyPeople: any
  peopleApiLoading: boolean
  publicStatus: boolean | undefined
  publicCompanyPageLoading: boolean
}) => {
  const { formatMessage } = useIntl()
  const [isDesignation, setIsDesignation] = useState(false)
  const [showPeopleModal, setShowPeopleModal] = useState(false)
  const [companyPeopleId, setCompanyPeopleId] = useState()
  const [showDeleteModal, setDeleteShowModal] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [updateModalStatus, setUpdateModalStatus] = useState(false)
  const [singlePeopleData, setSinglePeopleData] = useState<any>()
  const { currentUser } = useAuth()

  useEffect(() => {
    if (companyPeopleId) {
      getSinglePeople()
    }
  }, [companyPeopleId]) // eslint-disable-line react-hooks/exhaustive-deps

  const getSinglePeople = async () => {
    try {
      const {
        data: { data, success, errors },
      } = await getSingleCompanyPeople(companyPeopleId!)
      if (success) {
        setSinglePeopleData(data)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handlePeopleDelete = async (companyPeopleId: number) => {
    try {
      setDeleteLoading(true)
      if (companyPeopleId) {
        const {
          data: { success, errors },
        } = await deletePeople(companyPeopleId)
        if (success) {
          setDeleteLoading(false)
          setDeleteShowModal(false)
          getAllCompanyPeople()
          toast.success(formatMessage({ id: 'Company People deleted successfully' }))
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeletePeopleSuccessful,
              action: 'normal',
              metadata: {
                company_people_id: companyPeopleId,
                name: singlePeopleData?.name || '',
                email: singlePeopleData?.email || '',
                designation: designationOptions[singlePeopleData?.designation].value,
                linkedin_url: singlePeopleData?.linkedin_url || '',
                company_id: singlePeopleData?.companyId,
                user_id: currentUser?.userId,
              },
            },
          })
        } else {
          setDeleteLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.DeletePeopleFailed,
              action: 'normal',
              metadata: {
                company_people_id: companyPeopleId,
                name: singlePeopleData?.name || '',
                email: singlePeopleData?.email || '',
                designation: designationOptions[singlePeopleData?.designation].value,
                linkedin_url: singlePeopleData?.linkedin_url || '',
                company_id: singlePeopleData?.companyId,
                user_id: currentUser?.userId,
              },
            },
          })
        }
      }
    } catch (err) {
      setDeleteLoading(false)
      console.log(err)
    }
  }
  return (
    <>
      {(publicStatus === false ? peopleApiLoading : publicCompanyPageLoading) ? <Spinner /> : null}
      <div className='card p-7 mt-6 company-page-dark'>
        <div className='d-flex flex-column flex-md-row justify-content-between gap-2'>
          <div className='d-flex'>
            <p className='font-size-16 font-weight-600 m-0 '>{formatMessage({ id: 'People' })}</p>
          </div>
          {publicStatus === false && (
            <div className='d-flex gap-3'>
              <button
                className='btn bg-light custom-button-property text-muted py-3 w-100'
                onClick={() => {
                  setUpdateModalStatus(false)
                  setShowPeopleModal(true)
                }}
              >
                {formatMessage({ id: 'Add People' })}
              </button>
            </div>
          )}
        </div>
        {!peopleApiLoading && companyPeopleData.length === 0 ? (
          <NoDataPage width={`0`} bgTransparent={true} />
        ) : (
          <div>
            <div className='fw-bold text-muted col-12 d-flex font-size-13 w-100 pb-3 border-bottom mt-3 cursor-pointer'>
              <div
                className='card bg-clrf5f8 d-flex flex-row justify-content-between col-md-3 col-10 h-40px align-items-center border border-gray-300 rounded-0 rounded-start bg-clrF5 tabs-investordb company-page-dark dark_border_color'
                onClick={() => {
                  setIsDesignation(!isDesignation)
                  setSortByUser('name')
                  isDesignation ? setSortOrderUser('ASC') : setSortOrderUser('DESC')
                }}
              >
                <div className='font-size-13 fw-semibold ms-7'>{formatMessage({ id: 'Name' })}</div>
                <div className='me-3'>
                  {isDesignation ? (
                    <img src={toAbsoluteUrl('/media/icons/investor/UpArrow.svg')} alt='up arrow' />
                  ) : (
                    <img
                      src={toAbsoluteUrl('/media/icons/investor/DownArrow.svg')}
                      alt='Down arrow'
                    />
                  )}
                </div>
              </div>
              <div className='position-relative w-100 search-container'>
                <div className='search-icon'>
                  <img src={toAbsoluteUrl('/media/icons/investor/search.svg')} alt='search icon' />
                </div>
                <input
                  type='search'
                  className='company-page-dark dark_border_color w-100 h-40px  border border-gray-300 rounded-end  ps-12 d-md-block d-none font-size-13 tabs-investordb text_clr56'
                  id='placeholder_text_color'
                  placeholder={formatMessage({ id: 'Search People' })}
                  onChange={(e) => setSearchInvestorUser(e.target.value)}
                />
              </div>
            </div>
            <div className='table-responsive'>
              <table className='table table-row-bordered align-middle gs-1 gy-3 mt-0 mb-20'>
                <tbody>
                  {companyPeopleData &&
                    companyPeopleData?.map((user: any) => (
                      <tr key={user.companyPeopleId}>
                        <td>
                          <div className='text-dark  font-size-13 w-100px w-md-50'>
                            <span className='cursor-pointer'>{user.name ? user.name : '-'}</span>
                            {user?.linkedin_url && (
                              <span className='ms-2'>
                                <a href={user?.linkedin_url} target='_blank' rel='noreferrer'>
                                  <img
                                    src={toAbsoluteUrl('/media/icons/duotune/social/linkedin.svg')}
                                    width='16px'
                                    height='16px'
                                    alt={formatMessage({ id: 'linkedin icon' })}
                                  />
                                </a>
                              </span>
                            )}
                          </div>
                        </td>
                        <td>
                          <div className='text-dark font-size-13'>
                            {user.designation ? user.designation : '-'}
                          </div>
                        </td>
                        <td>
                          <div className='text-dark font-size-13'>
                            {user.email ? (
                              <a href={`mailto:${user.email}`} className='text-primary'>
                                {user.email}
                              </a>
                            ) : (
                              '-'
                            )}
                          </div>
                        </td>
                        {publicStatus === false && (
                          <td className='text-left text-end position-relative '>
                            <div>
                              <Dropdown>
                                <div id='remove-investor'>
                                  <Dropdown.Toggle className='bi bi-three-dots-vertical me-1 p-1 px-3 py-2 bg-light text-dark dark_bg_white'></Dropdown.Toggle>
                                </div>
                                <Dropdown.Menu className='m-2'>
                                  <Dropdown.Item className='text-primary'>
                                    <p
                                      className='mb-0'
                                      onClick={() => {
                                        setCompanyPeopleId(user.companyPeopleId)
                                        setUpdateModalStatus(true)
                                        setShowPeopleModal(true)
                                      }}
                                    >
                                      {formatMessage({ id: 'Edit' })}
                                    </p>
                                  </Dropdown.Item>
                                  <Dropdown.Item className='text-danger'>
                                    <p
                                      className='mb-0'
                                      onClick={() => {
                                        setCompanyPeopleId(user.companyPeopleId)
                                        setDeleteShowModal(true)
                                      }}
                                    >
                                      {formatMessage({ id: 'Delete' })}
                                    </p>
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
      <AddPeopleModal
        setShowPeopleModal={setShowPeopleModal}
        showPeopleModal={showPeopleModal}
        companyPeopleId={companyPeopleId}
        updateModalStatus={updateModalStatus}
        getAllCompanyPeople={getAllCompanyPeople}
      />
      <DeleteConfirmationModal
        showDeleteModal={showDeleteModal}
        setDeleteShowModal={setDeleteShowModal}
        headingMessage={formatMessage({ id: 'Delete Company People' })}
        description={formatMessage({ id: 'Are you sure you want to Delete this Company People?' })}
        handleDelete={handlePeopleDelete}
        deleteLoading={deleteLoading}
        id={companyPeopleId}
      />
    </>
  )
}
